export function apiGet<T>(path: string): Promise<T> {
  return fetch(path, {
    credentials: "same-origin",
    cache: "no-store",
    headers: { "Cache-Control": "no-cache" }
  }).then(async response => {
    const payload = await response.json().catch(() => null) as T | { error?: string } | null;
    if (!response.ok) {
      const message = typeof payload === "object" && payload && "error" in payload && payload.error
        ? payload.error
        : `Request failed: ${response.status}`;
      throw new Error(message);
    }
    return payload as T;
  });
}

export function apiPost<T>(path: string, body: Record<string, unknown>, csrfToken: string): Promise<T> {
  return fetch(path, {
    method: "POST",
    credentials: "same-origin",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {})
    },
    body: JSON.stringify(body)
  }).then(async response => {
    const payload = await response.json().catch(() => null) as T | { error?: string } | null;
    if (!response.ok) {
      const message = typeof payload === "object" && payload && "error" in payload && payload.error
        ? payload.error
        : `Request failed: ${response.status}`;
      throw new Error(message);
    }
    return payload as T;
  });
}
